export enum MessageEventTypes{
    CLOSE_EDIT_RUBRIC_OVERLAY = 'rubrics:closeEditRubricsOverlay',
    SAVE_RUBRIC_TO_QUESTION = 'rubrics:saveRubricToQuestion',
    RUBRICS_TEMPLATE_LIST_MODAL = 'author2wrapper:rubricsTemplateListModal',
    OPEN_RUBRICS_OVERLAY = 'author2wrapper:openRubricOverlay',
    AUTHOR2WRAPPER_RUBRIC_SAVED_TO_QUESTION = 'author2wrapper:rubricSavedToQuestion',
}
